import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/aboutPageImages/MissionVision/visionImage1.webp");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/aboutPageImages/MissionVision/visionImage2.webp");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/aboutPageImages/MissionVision/visionImage3.webp");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/aboutPageImages/MissionVision/visionImage4.webp");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/aboutPageImages/SecretaryImage/image.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/AboutCecPage/AboutCanara/AboutCanara.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/AboutCecPage/HeroSection/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/AboutCecPage/NextStepSection/NextStepSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/VideoPlayer/VideoPlayer.tsx");
